import { AuthGuard } from '../../../shared/services';
import { CagnottesDetailsComponent } from './cagnottes-details.component';
import { CagnottesDetailsResolver } from './cagnottes-details.resolver';
import { Route } from '@angular/router';

export const CagnottesDetailsRoutes: Route[] = [
  {
    path: ':id',
    component: CagnottesDetailsComponent,
    canActivate: [AuthGuard],
    resolve: {
      data: CagnottesDetailsResolver
    }
  }
];
